var _style, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClassLogoReversed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 71.4 71.3",
    style: {
      enableBackground: "new 0 0 71.4 71.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFBA00;}\n\t.st1{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M38.5,43.5H5c-2.8,0-5-2.2-5-5V5c0-2.8,2.2-5,5-5h33.5c2.8,0,5,2.2,5,5v33.5C43.5,41.3,41.3,43.5,38.5,43.5z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M66.5,43.2H53.9c-2.8,0-5-2.2-5-5V25.7c0-2.8,2.2-5,5-5h12.5c2.8,0,5,2.2,5,5v12.5 C71.5,41,69.2,43.2,66.5,43.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M66.4,71.3H53.8c-2.8,0-5-2.2-5-5V53.9c0-2.8,2.2-5,5-5h12.5c2.8,0,5,2.2,5,5v12.5 C71.4,69.1,69.1,71.4,66.4,71.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M38.7,71.2H26.2c-2.8,0-5-2.2-5-5V53.7c0-2.8,2.2-5,5-5h12.5c2.8,0,5,2.2,5,5v12.5 C43.7,69,41.4,71.2,38.7,71.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClassLogoReversed);
export default __webpack_public_path__ + "static/media/class-logo-reversed.fa6418077a1583edd2a12d7f380e8cc2.svg";
export { ForwardRef as ReactComponent };